import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class SocialLoginService {
  private oauthUrl = environment.idam_api_url + '/oauth2';
  private cloudUrl = environment.cloud_api_url + '/api.cloud.net/v1';

  constructor(private _http: HttpClient) {}

  public getInvitationSignUpAuthorizationUrl(socialName: any, recipientId: any): Observable<String> {
    const url = `${this.oauthUrl}/invitation-link/authorization/recipient/${recipientId}/url?tenant=tenant1&socialProviderName=${socialName}`;
    return this._http.get(url, {responseType: 'text'});
  }

  public getSocialInvitationSignUpOAuthCallback(socialName: any, code: any, state: any): Observable<any> {
    const url = `${this.oauthUrl}/sign-up/authorization/callback-url?tenant=tenant1&socialProviderName=${socialName}&code=${code}&state=${state}`;
    return this._http.get(url);
  }

  public getAuthenticationEmailSignUpOAuthCallback(socialName: any, code: any, state: any): Observable<any> {
    const url = `${this.oauthUrl}/authentication-email/sign-up/authorization/callback-url?tenant=tenant1&socialProviderName=${socialName}&code=${code}&state=${state}`;
    return this._http.get(url);
  }

  public socialLoginAuthorizationUrl(socialName: any): Observable<String> {
    const url = `${this.oauthUrl}/social-login/oauth/url?tenant=tenant1&socialProviderName=${socialName}`;
    return this._http.get(url, {responseType: 'text'});
  }

  public getContextualizedTokenForGuestAccount(socialName: any, code: any): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Tenant-ID': 'tenant1'
    });
    const url = `${this.oauthUrl}/social-login/oauth/contextualized-token?tenant=tenant1&socialProviderName=${socialName}&code=${code}`;
    return this._http.get(url, { observe: 'response', headers: headers });
  }

  public getThirdPartyAuthentications(organisationId: string): Observable<HttpResponse<any>> {
    const url = `${this.cloudUrl}/organisation/${organisationId}/third-authentication`;
    return this._http.get(url, { observe: 'response'});
  }

}
